import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Global Types
import { HarvestPrintProperty } from 'services/harvestPrintProperties/types';

// Global Selectors
import { makeSelectHarvestPrintPropertiesArray } from 'services/harvestPrintProperties/selectors';

// Global Utils
// @ts-ignore
import orderBy from 'utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectFilteredData = createDeepEqualSelector(
    makeSelectHarvestPrintPropertiesArray(),
    dataState => dataState.filter(value => !value.deletedAt)
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'orderIndex')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(
            ({ id, name, externalId }: HarvestPrintProperty) => ({
                key: id,
                text: `${externalId} (${name})`,
                value: id
            })
        )
);

export { selectOptions };
